module.exports = __webpack_public_path__ + "img/WX.png?525e6af87bc0505671231ea78ba4022f";